import React from 'react';
import { resolveFileUrl } from '../../../lib/portalApi';

const inputClass =
  'mt-1 w-full bg-black/40 border border-white/10 rounded-xl px-3 py-2 text-white text-sm';
const labelClass = 'text-xs text-white/45 uppercase tracking-wide';

/** Renders one dynamic question (all types including file). */
export function QuestionField({ question: q, value, onChange, onFile, existingUrl }) {
  const label = `${q.label}${q.required ? ' *' : ''}`;
  const choices = q.options?.choices || q.options || [];

  if (q.type === 'textarea') {
    return (
      <div>
        <label className={labelClass}>{label}</label>
        {q.helpText && <p className="text-xs text-white/35 mt-0.5">{q.helpText}</p>}
        <textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          rows={3}
          className={inputClass}
        />
      </div>
    );
  }

  if (q.type === 'select') {
    return (
      <div>
        <label className={labelClass}>{label}</label>
        <select value={value || ''} onChange={(e) => onChange(e.target.value)} className={inputClass}>
          <option value="">Select…</option>
          {(Array.isArray(choices) ? choices : []).map((o) => (
            <option key={o} value={o}>
              {o}
            </option>
          ))}
        </select>
      </div>
    );
  }

  if (q.type === 'multiselect') {
    const selected = Array.isArray(value) ? value : value ? [value] : [];
    return (
      <div>
        <label className={labelClass}>{label}</label>
        <div className="mt-2 space-y-1">
          {(Array.isArray(choices) ? choices : []).map((o) => {
            const checked = selected.includes(o);
            return (
              <label key={o} className="flex items-center gap-2 text-sm text-white/70">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => {
                    const next = checked ? selected.filter((x) => x !== o) : [...selected, o];
                    onChange(next);
                  }}
                />
                {o}
              </label>
            );
          })}
        </div>
      </div>
    );
  }

  if (q.type === 'file') {
    return (
      <div>
        <label className={labelClass}>{label}</label>
        {q.helpText && <p className="text-xs text-white/35 mt-0.5">{q.helpText}</p>}
        {existingUrl && (
          <a
            href={resolveFileUrl(existingUrl)}
            target="_blank"
            rel="noreferrer"
            className="block text-xs text-[#ff8ec5] mt-1"
          >
            Current file
          </a>
        )}
        <input
          type="file"
          className="mt-2 block text-sm text-white/60"
          onChange={(e) => onFile?.(e.target.files?.[0] || null)}
        />
      </div>
    );
  }

  return (
    <div>
      <label className={labelClass}>{label}</label>
      {q.helpText && <p className="text-xs text-white/35 mt-0.5">{q.helpText}</p>}
      <input
        type={q.type === 'number' ? 'number' : q.type === 'url' ? 'url' : 'text'}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={inputClass}
      />
    </div>
  );
}

export function DocumentField({ doc, onFile, existing }) {
  return (
    <div>
      <label className={labelClass}>
        {doc.label}
        {doc.required ? ' *' : ''}
      </label>
      {doc.description && <p className="text-xs text-white/35 mt-0.5">{doc.description}</p>}
      {existing?.url && (
        <a href={resolveFileUrl(existing.url)} target="_blank" rel="noreferrer" className="block text-xs text-[#ff8ec5] mt-1">
          {existing.originalName || 'Uploaded file'}
        </a>
      )}
      <input
        type="file"
        accept={doc.accept || undefined}
        className="mt-2 block text-sm text-white/60"
        onChange={(e) => onFile?.(e.target.files?.[0] || null)}
      />
    </div>
  );
}

export const QUESTION_TYPES = [
  'text',
  'textarea',
  'select',
  'multiselect',
  'url',
  'number',
  'file',
];

export default QuestionField;
